<template>
  <div class="animated fadeIn dashboard">
    <app-search-bar/>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Eventos Activos">
          <b-table hover
              responsive="sm" 
              class="registro eventos"
              :busy="tableEventosBusy"
              :items="eventos" 
              :fields="eventosFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(fechaInicio)="data">
              {{ data.item.fechaInicio | fecha }}
            </template>
            <template v-slot:cell(fechaFin)="data">
              {{ data.item.fechaFin | fecha }}
            </template>
            <!-- <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item
                    :disabled="data.item.sorteado" 
                    @click.stop="editarItem(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Evento</b-dropdown-item>

                <b-dropdown-item @click.stop="consultarParticipantes(data.item)">
                  <i class="fa fa-users"></i>Consultar Participantes</b-dropdown-item>

                <b-dropdown-item @click.stop="consultarSorteo(data.item)">
                  <i class="fa fa-trophy"></i>Consultar Sorteo</b-dropdown-item>
              </b-dropdown>
            </template> -->
          </b-table>
          <!-- <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="goEventos">Ir a Eventos</b-button>
          </div> -->
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Próximos Eventos">
          <b-table hover
              responsive="sm" 
              class="registro proximos-eventos"
              :busy="tableProximosEventosBusy"
              :items="proximosEventos" 
              :fields="proximosEventosFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(fechaInicio)="data">
              {{ data.item.fechaInicio | fecha }}
            </template>
            <template v-slot:cell(fechaFin)="data">
              {{ data.item.fechaFin | fecha }}
            </template>
            <!-- <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item
                    :disabled="data.item.sorteado" 
                    @click.stop="editarItem(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Evento</b-dropdown-item>

                <b-dropdown-item @click.stop="consultarParticipantes(data.item)">
                  <i class="fa fa-users"></i>Consultar Participantes</b-dropdown-item>

                <b-dropdown-item @click.stop="consultarSorteo(data.item)">
                  <i class="fa fa-trophy"></i>Consultar Sorteo</b-dropdown-item>
              </b-dropdown>
            </template> -->
          </b-table>
          <!-- <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="goEventos">Ir a Eventos</b-button>
          </div> -->
        </b-card>
      </b-col>
    </b-row>

    <!-- <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Próximos Sorteos Globales" v-if="sorteosGlobales.length != 0">
          <b-table hover
              responsive="sm" 
              class="registro sorteos-globales"
              :busy="tableSorteosGlobalesBusy"
              :items="sorteosGlobales" 
              :fields="sorteosGlobalesFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(fechaSorteo)="data">
              {{ data.item.fechaSorteo | fecha }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
import SearchBar from  './searchList/SearchBar.vue';

export default {
  name: 'dashboard',
  components: {
    appSearchBar: SearchBar
  },
  data() {
    return {
      eventos: [],
      tableEventosBusy: false,
      proximosEventos: [],
      tableProximosEventosBusy: false,
      eventosFields: [
        { 
          key: 'id',
          label: 'Nro.Evento'
        },
        { key: 'cliente' },
        { key: 'nombre' },
        { key: 'tipoEvento' },
        { 
          key: 'participantes',
          class: 'text-right'
        },
        { key: 'fechaInicio'},
        { key: 'fechaFin'},
        // {
        //   key: 'opciones',
        //   label: '',
        //   class: 'text-center'
        // },
      ],

      proximosEventosFields: [
        { 
          key: 'id',
          label: 'Nro.Evento'
        },
        { key: 'cliente' },
        { key: 'nombre' },
        { key: 'tipoEvento' },
        { key: 'fechaInicio'},
        { key: 'fechaFin'},
        // {
        //   key: 'opciones',
        //   label: '',
        //   class: 'text-center'
        // },
      ],

      // sorteosGlobales: [],
      // tableSorteosGlobalesBusy: false,
      // sorteosGlobalesFields: [
      //   { 
      //     key: 'id',
      //     label: 'Nro.'
      //   },
      //   { key: 'cliente'},
      //   { key: 'nombre'},
      //   { key: 'fechaSorteo'},
      //   // {
      //   //   key: 'opciones',
      //   //   label: '',
      //   //   class: 'text-center'
      //   // },
      // ],
    }
  },
  created() {
    // let userRolId = parseInt(this.$store.getters['user/rolId']);
    // if (userRolId == 1 || userRolId == 2 || userRolId == 6) {
    //   this.verUtilidades = true;
    //   this.verFondoInversion = true;
    // }

    this.tableEventosBusy = true;
    this.$store.dispatch('eventos/getEventosActivos')
      .then(() => {
        this.eventos = this.$store.getters['eventos/eventosActivos'];
        this.tableEventosBusy = false;
      });

    this.tableProximosEventosBusy = true;
    this.$store.dispatch('eventos/getProximosEventos')
      .then(() => {
        this.proximosEventos = this.$store.getters['eventos/proximosEventos'];
        this.tableProximosEventosBusy = false;
      });

    // this.tableSorteosGlobalesBusy = true;
    // this.$store.dispatch('sorteosGlobales/getProximosSorteosGlobales')
    //   .then(() => {
    //     this.sorteosGlobales = this.$store.getters['sorteosGlobales/proximosSorteosGlobales'];
    //     this.tableSorteosGlobalesBusy = false;
    //   });
  },    
  methods: {
    goEventos() {
      this.$router.push({ name: 'Eventos' });
    },
    // goSorteosGlobales() {
    //   this.$router.push({ name: 'SorteosGlobales' });
    // },
  }
}
</script>

<style>
  .dashboard .card-header {
    font-weight: bold;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .dashboard .card-body {
    padding-top: 10px;
    /* padding-bottom: 10px; */
  }
  .dashboard .card-footer {
    padding-top: 15px;
    padding-bottom: 15px;
    padding-right: 40px;
    text-align: right;
  }
  .dashboard .registro table th {
    border-top: none;
  }
  .dashboard .registro table tbody > tr > td:hover {
    cursor: default;
  }

  .dashboard .registro.eventos table td[aria-colindex="1"] {
    width: 10%;
  }
  .dashboard .registro.eventos table td[aria-colindex="2"] {
    width: 25%;
  }
  .dashboard .registro.eventos table td[aria-colindex="3"] {
    width: 30%;
  }
  .dashboard .registro.eventos table td[aria-colindex="4"] {
    width: 15%;
  }
  .dashboard .registro.eventos table td[aria-colindex="5"] {
    width: 10%;
  }
  .dashboard .registro.eventos table td[aria-colindex="6"],
  .dashboard .registro.eventos table td[aria-colindex="7"] {
    width: 10%;
  }

  .dashboard .registro.proximos-eventos table td[aria-colindex="1"] {
    width: 10%;
  }
  .dashboard .registro.proximos-eventos table td[aria-colindex="2"] {
    width: 25%;
  }
  .dashboard .registro.proximos-eventos table td[aria-colindex="3"] {
    width: 30%;
  }
  .dashboard .registro.proximos-eventos table td[aria-colindex="4"] {
    width: 15%;
  }
  .dashboard .registro.proximos-eventos table td[aria-colindex="5"],
  .dashboard .registro.proximos-eventos table td[aria-colindex="6"] {
    width: 10%;
  }

  .dashboard .registro.sorteos-globales table td[aria-colindex="1"] {
    width: 10%;
  }
  .dashboard .registro.sorteos-globales table td[aria-colindex="2"] {
    width: 25%;
  }
  .dashboard .registro.sorteos-globales table td[aria-colindex="3"] {
    width: 40%;
  }
  .dashboard .registro.sorteos-globales table td[aria-colindex="4"] {
    width: 25%;
  }
</style>
